import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n          visibility: visible;\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n          visibility: hidden;\n          transition: visibility 0s 0.4s;\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n      pointer-events: none;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  max-width: inherit;\n  width: 100%;\n  height: 100%;\n  z-index: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n          opacity: 1;\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n          opacity: 0;\n          //background-color: red;\n        "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  transition: opacity 0.3s;\n  ",
        ";\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  all: unset;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: 9;\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Close, Sizes } from "@/components/icon/IconList";
import Router from "next/router";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled, { css, useTheme } from "styled-components";
import { create } from "zustand";
import { lockScroll, unlockScroll, useDelayedState, useMounted } from "../../utils/misc";
const _handleOpitons = (options)=>{
    if (!options) {
        return;
    }
    if (options.afterClose) {
        setTimeout(options.afterClose, 400);
    }
};
export const useOverlayStore = create((set, get)=>({
        isBackKeyEnabled: false,
        stack: [],
        isLocked: false,
        setBackKeyEnabled: (isBackKeyEnabled)=>{
            set({
                isBackKeyEnabled: isBackKeyEnabled
            });
        },
        open: (options)=>{
            const { isBackKeyEnabled , isLocked  } = get();
            if (!isLocked) {
                // lockScroll()
                set({
                    isLocked: true
                });
            }
            if (isBackKeyEnabled && options.routeChange) {
                const url = new URL(location.href);
                if (Router.router) {
                    Router.router.isFirstPopStateEvent = true;
                }
                url.hash = options.name;
                history.pushState(history.state, "", url);
            }
            set((state)=>({
                    stack: state.stack.concat(options)
                }));
        },
        close: (options)=>{
            const { stack , isBackKeyEnabled , pop  } = get();
            if (stack.length === 0) {
                return;
            }
            const last = stack[stack.length - 1];
            if (isBackKeyEnabled && last.routeChange) {
                history.back();
                _handleOpitons(options);
                return;
            }
            pop(options);
        },
        pop: (options)=>{
            const { stack  } = get();
            if (stack.length === 0) {
                return;
            }
            const popped = stack[stack.length - 1];
            popped.onClose();
            if (stack.length === 1) {
                unlockScroll();
                set({
                    isLocked: false
                });
            }
            _handleOpitons(options);
            set((state)=>({
                    stack: state.stack.slice(0, -1)
                }));
        }
    }));
export const useCloseOverlay = ()=>useOverlayStore((state)=>state.close);
const Overlay = (param)=>{
    let { className , open , name , depth =1 , blocking =true , disableOutsideClick =false , onClose , children  } = param;
    const isMounted = useMounted();
    const [delayOpen, setDelayOpenImmediate, setDelayOpen] = useDelayedState(open);
    const ref = useRef(null);
    useEffect(()=>{
        if (open) {
            setDelayOpen(true);
            lockScroll();
        } else {
            setDelayOpenImmediate(false);
            unlockScroll();
        }
        return ()=>{
            unlockScroll();
        };
    }, [
        open
    ]);
    return isMounted ? /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(StyledOverlay, {
        id: name,
        open: open,
        delayOpen: delayOpen,
        depth: depth,
        className: className,
        ref: ref,
        children: [
            blocking && /*#__PURE__*/ _jsx(OverlayBg, {
                isOpen: open,
                onClick: ()=>!disableOutsideClick && onClose()
            }),
            children
        ]
    }), document.getElementById("overlay")) : null;
};
export default Overlay;
const StyledOverlay = styled.div.withConfig({
    componentId: "sc-63b143b1-0"
})(_templateObject3(), (props)=>1000 + props.depth, (param)=>{
    let { open  } = param;
    return open ? css(_templateObject()) : css(_templateObject1());
}, (param)=>{
    let { delayOpen  } = param;
    return !delayOpen && css(_templateObject2());
});
const OverlayBg = styled.div.withConfig({
    componentId: "sc-63b143b1-1"
})(_templateObject6(), (param)=>{
    let { isOpen  } = param;
    return isOpen ? css(_templateObject4()) : css(_templateObject5());
});
export const OverlayClose = (param)=>{
    let { onClose , color , size , noFixed =false  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(OverlayCloseBtn, {
        // css={!noFixed && overlayCloseCSS}
        className: "icon-btn",
        "aria-label": "닫기",
        onClick: ()=>onClose(),
        children: /*#__PURE__*/ _jsx(Icon, {
            icon: Close,
            color: color !== null && color !== void 0 ? color : theme.new.colors.black,
            size: size !== null && size !== void 0 ? size : Sizes.medium
        })
    });
};
const OverlayCloseBtn = styled.button.withConfig({
    componentId: "sc-63b143b1-2"
})(_templateObject7());
